import { permissionDeviceDetails } from '../utils/permissionDevices';
import { handleStreamEnded } from '../utils/streamEnded';

import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect } from 'react-router-dom';
import { changeState, logout, mudarMensagens } from '../actions/AppActions';
import { connect } from 'react-redux';

// users
import user4 from '../assets/images/users/user-4.jpg';
import moment from 'moment-timezone';
import NaoIniciada from './NaoIniciada';
import { DEBUG, URL } from '../variables';
import AceiteRegras from './AceiteRegras';
import AvaliacaoAndamento from './AvaliacaoAndamento';
import Finalizada from './Finalizada';
import MeetingRoom from './Meet';
//

import { createGlobalStyle } from 'styled-components';
import { ProgressBar } from 'react-bootstrap';
import { CircularProgress } from '@material-ui/core';
import Chat from './Chat';
import SweetAlert from 'react-bootstrap-sweetalert';
let silence = () => {
    let ctx = new AudioContext(), oscillator = ctx.createOscillator();
    let dst = oscillator.connect(ctx.createMediaStreamDestination());
    oscillator.start();
    return Object.assign(dst.stream.getAudioTracks()[0], { enabled: false });
}
const StyleQuestion = createGlobalStyle`
 *::selection {
    background-color: #f1c40f !important;
    color:black !important;
    font-weight:bold !important;
 }
`

export class ProcessoUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            nao_iniciado: false,
            regras_processo: false,
            andamento: false,
            finalizada: false,
            loading_screen: true,
            finish: false,
            full_screen: false,
            need_face_validation: false,
            chat_show: false,
            message_access: '',
            loading_access: false,
            request_validation: {},
            show_warning_decline: false,
            show_warning_approved: false,
            show_btn_validation_timer: false,
            show_btn_validation: false
        };
        this.last_date = moment().format('YYYY-MM-DD HH:mm:ss');
        this.need_delete_validation = []
    }




    solicitar_camera(rules) {
        // this.setState({ loading_camera: true, msg: '', show_solicitar: false });
        navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => this.get_camera(rules,stream)).catch(this.handleError.bind(this));
    }

    async get_camera(rules,stream_) {
        stream_.getTracks().map((track)=>track.stop());

        var devices = await navigator.mediaDevices.enumerateDevices();
        let device_local = localStorage.getItem("deviceId")
        console.log(devices);
        let exists = false;
        let devices_camera = [];
        let devices_mic = [];
        var _stream = null;
        let devices_cam_id = []
        let devices_mic_id = []

        for (let i = 0; i < devices.length; i++) {
            if (devices[i].kind == 'videoinput') {
                if (!devices_cam_id.includes(devices[i].deviceId)) {
                    devices_camera.push(devices[i]);
                    devices_cam_id.push(devices[i].deviceId);

                }
                if (device_local == devices[i].deviceId) {
                    exists = true;
                }
            }
            else if (devices[i].kind == 'audioinput') {
                if (!devices_mic_id.includes(devices[i].deviceId)) {
                    devices_mic.push(devices[i]);
                    devices_mic_id.push(devices[i].deviceId);

                }
            }

        }
        console.log(devices_camera);
        console.log('oi');
        if (devices_camera.length > 0 && devices_mic.length > 0 || true) {
            let use = '';
            if (exists == true) {
                use = device_local;
            }
            else if (devices_camera.length > 0) {
                use = devices_camera[0].deviceId;
                localStorage.setItem("deviceId", use);
            }
            let videoConstraints = {
                frameRate: 4,
                width: 320,
                height: 240
            };
            if (use) {
                videoConstraints.deviceId = { exact: use };
            }
            console.log(use)
            this.props.changeState({ devices_camera: devices_camera, devices_mic, device_select: use })
            navigator.mediaDevices.getUserMedia({
                video: videoConstraints, audio: true
            }).
                then((str) => this.handleSuccess(str, rules)).catch(this.handleError.bind(this));
        }
        else {
            this.setState({ show_solicitar: true, loading_camera: false, msg: 'Não foi reconhecido nenhuma câmera ou microfone conectado em seu computador. Conecte e tente novamente' })
        }
    }


    handleSuccess(stream, rules) {
        handleStreamEnded(stream, (event) => {
            try {
                this.salvar_log_permission('Captura de ' + (event.target?.kind === 'audio' ? 'microfone' : 'câmera') + ' encerrada. ' + permissionDeviceDetails(stream));
            }
            catch (e) {

            }
            this.props.history.push({
                pathname: '/',
                search: '?error=Compartilhamento de Vídeo/Áudio foi cancelado pelo candidato. Compartilhe novamente para realizar a avaliação'
            });
        });
        // this.get_processo();
        this.registrarDispositivos(stream, 'Aceitou permissão de câmera e microfone');


        this.props.changeState({ stream });
        this.aceitar_regras(this.resp);
        this.get_time_server();

    }

    handleError(stream) {
        console.log(stream);
        let msg = '';
        if (stream.name === 'NotAllowedError' || stream.toString().includes('NotAllowedError') || stream.toString().includes('Permission denied')) {
            msg = 'O navegador bloqueou o acesso à câmera ou ao microfone. Libere câmera e microfone nas permissões do navegador e do sistema operacional, feche outros aplicativos que possam estar usando os dispositivos e tente novamente.';
        }
        else if (stream.toString().includes('Permission dismissed')) {
            msg = 'Aceita as permissões de acesso a câmera para poder avançar.';
        }
        else if (stream.toString().includes('Could not start video source')) {
            msg = 'Não foi possível acessar sua câmera. Conecte uma câmera, feche todas suas outras aplicações e tente novamente.';
        }
        else if (stream.toString().includes('Could not start audio source')) {
            msg = 'Não foi possível acessar seu microfone. Conecte um microfone, feche todas suas outras aplicações e tente novamente.';
        }
        else if (stream.toString().includes('NotFoundError')) {
            msg = 'Não foram reconhecidos nenhuma câmera ou microfone conectados em seu computador. Conecte-os e tente novamente.';
        }
        else {
            msg = stream.toString();
        }
        this.salvar_log_permission(msg + ' ' + stream.toString());
        this.setState({ redirect: true });

    }

    registrarDispositivos(stream, mensagem = 'Dispositivos de câmera e microfone em uso') {
        if (!stream || typeof stream.getTracks !== 'function' || this.permission_devices_stream === stream) return;
        this.permission_devices_stream = stream;
        this.salvar_log_permission(mensagem + ': ' + permissionDeviceDetails(stream));
    }

    componentDidUpdate(previousProps) {
        if (previousProps.stream !== this.props.stream) this.registrarDispositivos(this.props.stream);
    }

    componentDidMount() {
        this.registrarDispositivos(this.props.stream);
        this.clicked = false;
        this.unmount = false;
        this.get_processo();
    }

    salvar_log_permission(msg, type = 'permission') {
        fetch(`${URL}api/external/salvar_log?screen=${type}&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}&msg=${encodeURIComponent(msg)}&external=1`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {

                }
            } catch (err) {
                console.log(err);

            }

        })
            .catch((err) => {
                console.log(err);

            });
    }


    componentWillUnmount() {
        this.unmount = true;

        clearTimeout(this.timeout_get_processo)
        clearTimeout(this.timeout_timeserver)
        clearTimeout(this.timer_timeout)
        clearTimeout(this.request_access_timeout)
        clearTimeout(this.timeout_btn_validation)
        clearInterval(this.timeout_request_delete)
        clearInterval(this.timeout_validation)
    }




    get_processo(flag = '') {
        if (this.props.processo != null && this.props.processo.is_interview && this.props.socket != null) {
            this.props.socket.emit('exit_call', { aluno_id: this.props.user.id, processo_id: this.props.processo.id, id: this.props.user.id })
        }

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/external/get_processo${flag}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == 'Server Error') {
                    this.timeout_get_processo = setTimeout(() => {
                        this.get_processo();
                    }, 5000);
                    return;
                }
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;

                }
                if (resp.errors != null || resp.error != null || resp.message == 'Server Error') {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    // this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                    this.timeout_get_processo = setTimeout(() => {
                        this.get_processo();
                    }, 5000);
                }
                else {
                    this.resp = resp;
                    if (resp.processo != null && (resp.processo.type_fiscalization == 'all' || resp.processo.type_fiscalization == 'image') && this.props.stream == null && resp.processo_resultado != null && resp.processo_resultado.status == 'I') {
                        // this.setState({ loading_screen: true });

                        this.solicitar_camera(true);
                    }
                    else {
                        this.aceitar_regras(resp);
                    }


                }
            } catch (err) {
                // this.setState({ redirect: true });
                console.log(err);
                this.timeout_get_processo = setTimeout(() => {
                    this.get_processo();
                }, 5000);
            }

        })
            .catch((err) => {
                // this.setState({ redirect: true });

                console.log(err);
                this.timeout_get_processo = setTimeout(() => {
                    this.get_processo();
                }, 5000);
            });
    }
    goToRules(flag = '') {
        // this.get_time_server();
        this.get_processo(flag);

    }

    aceitar_regras(resp) {
        if (resp.not_processo == true) {
            this.props.changeState({ processo: null });
            return;
        }

        // this.props.mudarUser(resp.user);
        // this.props.mudarProcesso(resp.processo);
        // this.props.mudarSala(resp.sala);
        // this.props.mudarTempoAtual(resp.tempo_atual);
        // if (this.props.stream == null && resp.finish != true ) {
        //     this.solicitar_camera();
        //     return;
        // }
        let processo_resultado = {};
        if (resp.processo_resultado != null) {
            processo_resultado.processo_resultado = resp.processo_resultado;
        }


        this.props.changeState({ request_user: resp.request_user, entrevistas: resp.entrevistas, mensagens: resp.mensagens, redacoes: resp.redacoes, questionarios: resp.questionarios, provas: resp.provas, categorias: resp.categorias, user: resp.user, processo: resp.processo, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });

        // else if (resp.processo.fim != this.props.processo.fim || resp.processo.updated_at != this.props.processo.updated_at) {
        //     this.props.changeState({ mensagens: resp.mensagens, redacoes: resp.redacoes,questionarios: resp.questionarios, provas: resp.provas, categorias: resp.categorias, user: resp.user, processo: resp.processo, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
        // }
        // else {
        //     this.props.changeState({ mensagens: resp.mensagens, redacoes: resp.redacoes,questionarios: resp.questionarios, provas: resp.provas, categorias: resp.categorias, user: resp.user, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
        // }
        this.setState({
            request_validation: resp.request_validation != null ? resp.request_validation : this.state.request_validation,
            need_face_validation: (this.validation == true || this.state.request_validation?.approved == true || (this.props.left_movement == true && this.props.center_movement && this.props.right_movement && this.props.audio_detected)) ? false : true,
            loading_screen: false,
            finish: resp.finish == true,
            nao_iniciado: resp.nao_iniciado == true,
            regras_processo: false,
            andamento: resp.andamento == true,
            finalizada: false
        });
        if (resp.tempo_atual) {
            clearTimeout(this.timer_timeout);
            this.seconds_diff = moment(resp.tempo_atual).diff(moment(), 'seconds');
            this.last_date = moment().format('YYYY-MM-DD HH:mm:ss');
            this.incTimer();
        }



    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }







    get_time_server() {

        fetch(`${URL}api/get_time_server`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                else if (resp.message == "Server Error") {
                    this.timeout_timeserver = setTimeout(() => {
                        this.get_time_server();
                    }, 5000);
                }
                else {
                    if (resp.atual != null) {
                        this.seconds_diff = moment(resp.atual).diff(moment(), 'seconds');
                        this.props.changeState({ tempo_atual: resp.atual });
                    }
                }
            } catch (err) {
                console.log(err);

            }

        })
            .catch((err) => {
                console.log(err);
                this.timeout_timeserver = setTimeout(() => {
                    this.get_time_server();
                }, 5000);
            });
    }



    incTimer() {
        // var currentMinutes = Math.floor(totalSecs / 60);
        let last_date_new = moment().format('YYYY-MM-DD HH:mm:ss');

        let diff = moment().tz('America/Sao_Paulo').diff(this.last_date, 'seconds');
        this.last_date = last_date_new;

        let before_second_diff = this.seconds_diff;
        console.log(this.seconds_diff)

        if (Math.abs(diff) >= 2) {
            // console.log('Tempo');
            // console.log(seconds_diff);

            // console.log('Diff');
            // console.log(diff);

            this.seconds_diff = this.seconds_diff + (-1 * diff) + 1;

            // console.log('Tempo new');
            // console.log(seconds_diff);

        }
        console.log(this.seconds_diff)

        var totalSecs = moment(this.props.processo.inicio, 'YYYY-MM-DD HH:mm:ss').diff(moment().add(this.seconds_diff, 'seconds').format('YYYY-MM-DD HH:mm:ss'), 'seconds');

        // console.log($('#inicio_id').val())
        // console.log(moment().tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss'))
        // var totalSecs = tempo - iniciado;
        var currentHours = Math.floor((totalSecs / 60) / 60);
        var currentMinutes = Math.floor(totalSecs / 60) - currentHours * 60

        var currentSeconds = totalSecs % 60;
        if (currentSeconds <= 9) currentSeconds = "0" + currentSeconds;
        if (currentMinutes <= 9) currentMinutes = "0" + currentMinutes;
        if (currentHours <= 9) currentHours = "0" + currentHours;

        // totalSecs--;
        console.log(totalSecs)
        let data = {}
        if (totalSecs <= this.props.processo.chat_time && this.state.chat_show == false) {
            data.chat_show = true;
        }
        if (totalSecs <= this.props.processo.request_time && this.state.show_btn_validation_timer == false) {
            console.log('entrou')
            data.show_btn_validation_timer = true;
        }
        else {
            if (totalSecs % 30 == 0 && this.state.show_btn_validation_timer == false) {
                this.get_time_server()
            }
        }
        if (Object.keys(data).length != 0) {
            this.setState(data);
        }
        // if(document.getElementById('total_secs')!=null){
        //     try{
        //         document.getElementById('total_secs').innerText=totalSecs+'_'+before_second_diff+'_'+this.seconds_diff;
        //     }
        //     catch(e){

        //     }
        // }
        if (totalSecs <= 0) {
            totalSecs = 0;
            this.iniciado = true;
        }
        else {


            this.timer_timeout = setTimeout(function () {
                this.incTimer()
            }.bind(this), 1000);
        }
    }


    renderTips() {
        if (this.props.processo.face_validation == true) {
            if (this.props.loading_media) {
                return (<div className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress style={{ marginRight: 5 }} size={18} color='inherit' /> <span>Carregando informações...</span></div>)
            }
            else if (this.props.face_detected == false && this.props.multipleface_detected == false) {
                console.log('nenhum rosto');
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>Nenhum rosto detectado. Mude a posição da câmera ou altere o dispositivo.</p>)
            }
            else if (this.props.face_detected == false && this.props.multipleface_detected == true) {
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>Mais de um rosto detectado. Para entrar na avaliação você deve estar em um ambiente sozinho.</p>)
            }
            else if (this.props.center_movement == false) {
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>Centralize o rosto na câmera para ser detectado</p>)
            }
            else if (this.props.right_movement == false) {
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>Vire seu rosto para o lado direito</p>)
            }
            else if (this.props.left_movement == false) {
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>Vire seu rosto para o lado esquerdo</p>)
            }
            else if (this.props.audio_detected == false) {
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>Fale alto a frase "Estou aqui" para validar seu microfone</p>)
            }
            else {
                return (<p className='blink_success' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'green', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>Validação de dispositivo concluída - Clique no botão abaixo para prosseguir</p>)
            }
        }
        else {
            return '';
        }
    }

    access_exam() {
        this.validation = true;
        this.get_time_server()

        this.props.changeStateParent({ show_btn_change: false })
        this.setState({ need_face_validation: false, show_warning_approved: false, show_btn_validation: false }, () => {
            if (this.clicked == false && this.props.processo.full_screen == true) {
                this.clicked = true;
            }
        });

    }


    render() {//
        return (
            <div className="row" onClick={() => {
                document.body.style.userSelect = 'text';
            }} onCopy={(e) => {
                e.preventDefault();
            }}
                onCut={(e) => e.preventDefault()}
                onDrop={(e) => e.preventDefault()}
                onChange={(e) => e.preventDefault()}

            >
                {this.props.user?.accessibility == true && this.props.user?.type_supervisor != 'none' && <StyleQuestion />}
                {this.state.redirect == true && <Redirect to={this.state.path} />}

                <div className="col-12">
                    <div className="card mb-0" style={{
                        borderBottom: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0
                    }}>
                        <div className="card-body" id="card">
                            <div hidden id="total_secs"></div>

                            <h4 className="mt-0 header-title" id='titulo_processo' style={{ fontSize: '1.5rem', color: 'black' }}>{this.props.processo.name}</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>Nome do candidato: {this.props.user.name}</p>

                            {this.props.processo.type_time == 'all' && <>
                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>Hora de início: </b>
                                    {moment(this.props.processo.inicio).format('DD/MM/YYYY HH:mm')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>Hora de encerramento: </b>
                                    {moment(this.props.processo.fim).format('DD/MM/YYYY HH:mm')}
                                </p>
                            </>}

                            {this.props.processo.type_time == 'restrict' && this.props.processo.inicio_absoluto == null && <>
                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>Hora de início do processo: </b>
                                    {moment(this.props.processo.inicio).format('DD/MM/YYYY HH:mm')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>Hora de encerramento do processo: </b>
                                    {moment(this.props.processo.fim).format('DD/MM/YYYY HH:mm')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>Iniciado em: </b>
                                    -
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>Finaliza em: </b>
                                    -
                                </p>
                            </>}

                            {this.props.processo.type_time == 'restrict' && this.props.processo.inicio_absoluto != null && <>
                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>Hora de início do processo: </b>
                                    {moment(this.props.processo.inicio_absoluto).format('DD/MM/YYYY HH:mm')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>Hora de encerramento do processo: </b>
                                    {moment(this.props.processo.fim_absoluto).format('DD/MM/YYYY HH:mm')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>Iniciado em: </b>
                                    {moment(this.props.processo.inicio).format('DD/MM/YYYY HH:mm:ss')}
                                </p>

                                <p className="m-b-20" style={{ color: 'black', marginBottom: '0.4rem' }}><b>Finaliza em: </b>
                                    {moment(this.props.processo.fim).format('DD/MM/YYYY HH:mm:ss')}
                                </p>
                            </>}

                            <hr />
                            
                            {this.state.loading_screen == false && <div>
                                {<>
                                    <p className="m-b-20" style={{ color: 'black', whiteSpace: 'pre-line', fontSize: '1rem' }}><b style={{ fontWeight: 'bold' }}>Descrição da avaliação: </b>
                                        {"\n"}
                                        {this.props.processo.descricao}
                                    </p>
                                    <div >


                                        {this.state.nao_iniciado && <NaoIniciada send_message={(m) => this.send_message(m)} goToRules={this.goToRules.bind(this)} get_processo={this.get_processo.bind(this)} {...this.props} />}
                                        {this.state.andamento && <AvaliacaoAndamento changeStateParent={(e) => this.props.changeStateParent(e)} getValues={() => this.props.getValues()} send_message={(m) => this.send_message(m)} aceitar_regras={this.aceitar_regras.bind(this)} get_processo={this.get_processo.bind(this)} {...this.props} />}
                                        {this.state.finish && <Finalizada changeStateParent={(e) => this.props.changeStateParent(e)} getValues={() => this.props.getValues()} send_message={(m) => this.send_message(m)} aceitar_regras={this.aceitar_regras.bind(this)} get_processo={this.get_processo.bind(this)} {...this.props} />}
                                    
                                    </div>


                                </>}

                            </div>}
                            {<div id='timer'
                                className='timer_exam'>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status"  >
                                    <span className="sr-only">Loading...</span>
                                </div>
                                <h6 style={{ textAlign: 'center' }}>Carregando dados. Por favor, aguarde.</h6>
                            </div>

                            </div>}


                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
const mapsStateToProps = (state) => (
    {
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
        token: state.AppReducer.token,
        stream: state.AppReducer.stream,
        stream_screen: state.AppReducer.stream_screen,

        processo_resultado: state.AppReducer.processo_resultado,
        // worker: state.AppReducer.worker,
        sala: state.AppReducer.sala,
        faculdade: state.AppReducer.faculdade,
        show_call: state.AppReducer.show_call,
        mensagens: state.AppReducer.mensagens,

        socket: state.AppReducer.socket,
        connect: state.AppReducer.connect,
        request_user: state.AppReducer.request_user,


    }
);

export default connect(mapsStateToProps, { changeState, logout, mudarMensagens })(ProcessoUser);
